module.exports = __webpack_public_path__ + "media/src/img/favicon_new_year-e65117ad92212fd15b2ff67303b62dd5.ico";